<template>
  <b-form-group :label="value.label">
    <date-picker v-model="value.value" :config="options" :disabled="disabled"/>
  </b-form-group>
</template>
<script>
import DatePicker from "vue-bootstrap-datetimepicker";
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';

export default {
  props: ['value', 'disabled'],
  data() {
    return {
      options: {
        locale: 'nl-NL',
        format: 'DD-MM-YYYY',
        calendarWeeks: true,
        useCurrent: false
      }
    }
  },
  components: { DatePicker },
}

</script>
